// import axiosInstance from "../../../axios";
// import config from "../../../config";
// import { usePersistedStore } from "../../persisted-store";

// export const createSmsReportSlice = (set, get) => ({
//     crmSmsReport: {
//         loading: false,
//         data: []
//     },
//     getCrmSmsReport: async (UsrUserID) => {
//         const token = usePersistedStore.getState().business.currentBusiness.token;
//         set(state => ({ crmSmsReport: { ...state.crmSmsReport, loading: true } }));
//         try {
//             const resp = await axiosInstance({
//                 method: 'get',
//                 baseURL: config.apiUrls(),
//                 url: `v1/crm/sms-report/user/${UsrUserID}`,
//                 headers: { token }
//             });
//             set(state => ({ crmSmsReport: { loading: false, data: resp.data } }));
//         } catch (error) {
//             set(state => ({ crmSmsReport: { ...state.crmSmsReport, loading: false } }));
//         }
//     }
// });


import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createSmsReportSlice = (set, get) => ({
    crmSmsReport: {
        loading: false,
        data: []
    },
    getCrmSmsReport: async (params) => {


        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ crmSmsReport: { ...state.crmSmsReport, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: 'post',
                baseURL: config.apiUrls(),
                url: `v1/crm/sms-report/user/${params.usrUserID}`,
                headers: { token },
                data: {
                    PageNumber: params.PageNumber,
                    PageSize: params.PageSize,
                },
            });
            set(state => ({ crmSmsReport: { loading: false, data: resp.data } }));
        } catch (error) {
            set(state => ({ crmSmsReport: { ...state.crmSmsReport, loading: false } }));
        }
    }
});
